import { useEffect } from "react";

import i18n, { SUPPORTED_LANGUAGES } from "@/i18n";

/**
 * Syncs the Auth0 transaction locale to i18n when a supported locale is explicitly provided.
 * When locale is undefined or unsupported, does nothing so the user's stored preference is preserved.
 */
export function useAuth0Locale(locale: string | undefined): void {
  useEffect(() => {
    if (
      !SUPPORTED_LANGUAGES.includes(
        locale as (typeof SUPPORTED_LANGUAGES)[number]
      )
    )
      return;
    void i18n.changeLanguage(locale!);
  }, [locale]);
}
